import { createContext, useContext } from 'react';
import type { PropsWithChildren } from 'react';

import type { BookingSession } from '@/features/bookings-management/types';

type JobSupportSessionsProviderProps = PropsWithChildren<{
  sessionsById: Map<number, BookingSession>;
}>;

const JobSupportSessionsContext = createContext<Map<number, BookingSession>>(
  new Map()
);

export const JobSupportSessionsProvider = ({
  children,
  sessionsById,
}: JobSupportSessionsProviderProps) => (
  <JobSupportSessionsContext.Provider value={sessionsById}>
    {children}
  </JobSupportSessionsContext.Provider>
);

export const useJobSupportSession = (sessionId?: number | null) => {
  const sessionsById = useContext(JobSupportSessionsContext);

  return sessionId ? sessionsById.get(sessionId) : undefined;
};
